import { render, staticRenderFns } from "./LaidOutSelectInput.vue?vue&type=template&id=5b1405de&"
import script from "./LaidOutSelectInput.vue?vue&type=script&lang=js&"
export * from "./LaidOutSelectInput.vue?vue&type=script&lang=js&"
import style0 from "./LaidOutSelectInput.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib'
installComponents(component, {
  VChip,
})
